import { parseUtc } from './dateUtils';

export const formatTimeSincePosting = (value, now = new Date()) => {
  if (!value) return '';
  const createdAt = parseUtc(value);
  const createdAtMs = createdAt.getTime();
  if (!Number.isFinite(createdAtMs)) return '';

  const diffMs = Math.max(0, now.getTime() - createdAtMs);
  const minuteMs = 60 * 1000;
  const hourMs = 60 * minuteMs;
  const dayMs = 24 * hourMs;
  const weekMs = 7 * dayMs;
  const monthMs = 30 * dayMs;
  const yearMs = 365 * dayMs;

  if (diffMs < minuteMs) return 'Just Now';
  if (diffMs < hourMs) return `${Math.floor(diffMs / minuteMs)} m`;
  if (diffMs < dayMs) return `${Math.floor(diffMs / hourMs)} h`;
  if (diffMs < weekMs) return `${Math.floor(diffMs / dayMs)} d`;
  if (diffMs < 5 * weekMs) return `${Math.floor(diffMs / weekMs)} w`;
  if (diffMs < yearMs) return `${Math.floor(diffMs / monthMs)} m`;
  return `${Math.floor(diffMs / yearMs)} y`;
};
